import store from '../../store'
import find from 'lodash/find'
import {updateTeamForRecurringEventRequest} from '../../actions/meetings'

export function updateTeamForRecurringEvent(eventId,team) {	
	store.dispatch(updateTeamForRecurringEventRequest(eventId,team))
}

